import { Nullable, Dictionary } from '../../../../global/types';
import { RuntimeModel } from '../../types';
import { unique } from '../../../../utils/array/unique';
import { getPromiseResults } from '../../../../utils/promise/getPromiseResults';
import { mapToObject } from '../../../../utils/object';

export function setProductUrls(
  model: RuntimeModel,
  urls: Dictionary<string>,
): RuntimeModel {
  if (!model.product.url && urls[model.product.id]) {
    model.product.url = urls[model.product.id];
  }
  model.bundles.forEach((bundle) => {
    if (!bundle.url && urls[bundle.id]) {
      bundle.url = urls[bundle.id];
    }
  });
  return model;
}

export function getProductIdsWithoutUrl(model: RuntimeModel): string[] {
  const results: string[] = [];
  if (!model.product.url) {
    results.push(model.product.id);
  }
  model.bundles.forEach((bundle) => {
    if (!bundle.url) {
      results.push(bundle.id);
    }
  });
  return unique(results);
}

export async function setModelProductUrls(
  model: RuntimeModel,
  getProductIdByUrl?: Nullable<(id: string) => Promise<string>>,
): Promise<RuntimeModel> {
  if (typeof getProductIdByUrl === 'function') {
    const ids = getProductIdsWithoutUrl(model);
    const urls = await getPromiseResults(ids, getProductIdByUrl);
    model = setProductUrls(model, mapToObject(urls));
  }
  return model;
}
